import * as React from 'react'
import type { SVGProps } from 'react'
const SvgReviewProxyway = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={147}
    height={59}
    fill="none"
    viewBox="0 0 147 59"
    {...props}
  >
    <g clipPath="url(#a)">
      <g clipPath="url(#b)">
        <g clipPath="url(#c)" mask="url(#mask0_1653_1112)">
          <path
            fill="#F70340"
            d="m10.147 55.44-6.065 3.394 1.354-6.818-5.103-4.719 6.903-.819 2.911-6.311 2.912 6.311 6.903.82-5.104 4.718 1.354 6.818zM29.78 55.44l-6.065 3.394 1.354-6.817-5.103-4.72 6.902-.819 2.912-6.311 2.912 6.311 6.902.82-5.104 4.719 1.355 6.817zM49.409 55.44l-6.065 3.394 1.354-6.818-5.103-4.719 6.902-.819 2.912-6.311 2.912 6.311 6.902.82-5.104 4.718 1.355 6.818zM69.038 55.44l-6.065 3.394 1.354-6.817-5.103-4.72 6.902-.819 2.912-6.311 2.912 6.311 6.902.82-5.104 4.719 1.355 6.817z"
          />
          <path
            stroke="#F70340"
            strokeWidth={1.333}
            d="m88.994 54.857-.325-.182-.326.182-4.804 2.69 1.073-5.4.073-.367-.274-.253-4.043-3.738 5.468-.648.37-.044.156-.34 2.307-4.998 2.306 4.999.156.338.37.045 5.468.648-4.042 3.738-.275.253.073.366 1.073 5.4z"
          />
          <path
            fill="#101828"
            d="M27.935 14.231h3.436a4 4 0 0 1 2.72.87 2.98 2.98 0 0 1 1.005 2.371 3.02 3.02 0 0 1-.99 2.396 4.02 4.02 0 0 1-2.746.87h-1.015v3.003h-2.41zm2.407 4.605h.664q1.667 0 1.667-1.364a1.21 1.21 0 0 0-.414-1.007 2 2 0 0 0-1.253-.331h-.664zM36.47 14.231h3.436a4.04 4.04 0 0 1 2.74.857 2.97 2.97 0 0 1 .983 2.359 2.9 2.9 0 0 1-.375 1.457c-.252.447-.62.817-1.066 1.07l2.369 3.767h-2.758l-1.667-3.078h-.194q-.12-.002-.226.006c-.07.007-.119.006-.144.006h-.687v3.066h-2.407zm2.406 4.542h.688q1.654 0 1.654-1.339a1.18 1.18 0 0 0-.4-.982 1.96 1.96 0 0 0-1.229-.317h-.715zM50.11 23.94a5.5 5.5 0 0 1-2.608-.613 4.7 4.7 0 0 1-1.855-1.745 5.14 5.14 0 0 1-.044-5.061 4.85 4.85 0 0 1 1.83-1.808 5.27 5.27 0 0 1 2.676-.682 5.5 5.5 0 0 1 2.608.613c.768.4 1.41 1.004 1.855 1.745a5.13 5.13 0 0 1 .044 5.061 4.85 4.85 0 0 1-1.83 1.808 5.27 5.27 0 0 1-2.677.683m0-2.216a2.53 2.53 0 0 0 1.303-.338c.388-.229.705-.56.916-.957.232-.44.348-.934.338-1.432.007-.485-.1-.966-.314-1.402a2.4 2.4 0 0 0-.898-.988 2.5 2.5 0 0 0-1.348-.363 2.53 2.53 0 0 0-1.303.338c-.388.229-.705.56-.915.957a2.94 2.94 0 0 0-.339 1.433c-.007.485.1.965.314 1.402.2.407.512.75.898.988.405.247.873.373 1.347.364zM58.82 18.786l-3.095-4.555h2.946l1.717 2.89 1.667-2.89h2.87l-3.119 4.655 3.31 4.855h-2.971l-1.93-3.178-1.843 3.178H55.5zM68.922 19.874l-3.437-5.643h2.784l1.93 3.691 1.943-3.69h2.707l-3.447 5.642v3.866H68.92zM75.392 14.231h2.643l1.427 6.256 1.768-6.13h2.106l1.793 6.015 1.403-6.143h2.644l-2.82 9.51h-2.282l-1.817-6.12-1.78 6.12h-2.281zM92.29 14.231h2.607l3.736 9.51h-2.644l-.74-2.19h-3.472l-.727 2.19h-2.494zm2.306 5.405-1.09-3.24-1.09 3.24zM101.074 19.874l-3.436-5.643h2.782l1.931 3.691 1.943-3.69h2.707l-3.447 5.642v3.866h-2.482z"
          />
          <path
            fill="#F70340"
            d="M10.861 29.21a10.55 10.55 0 0 1-7.067-2.728 10.508 10.508 0 0 1-1.398-14.047 10.558 10.558 0 0 1 13.862-2.794 10.53 10.53 0 0 1 4.689 5.942c.77 2.493.586 5.182-.517 7.546a10.53 10.53 0 0 1-5.453 5.251 10.5 10.5 0 0 1-4.116.83M2.931 14.96l11.631 11.61v-2.764L5.7 14.96zm.183 6.266v2.396l2.77 2.764h2.4zm2.124-2.12v2.398l2.77 2.764h2.4zm4.708-4.146H7.547l7.017 7.003v-2.396zm1.846 0 2.77 2.765V14.96z"
          />
          <path
            fill="#F70340"
            fillRule="evenodd"
            d="m88.736 40.308-.065-.141-2.912 6.311-6.903.82 5.104 4.718-1.354 6.818 6.065-3.395.065.037z"
            clipRule="evenodd"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M.333.165H147v58.67H.333z" />
      </clipPath>
      <clipPath id="b">
        <path fill="currentColor" d="M.333.165h106.67v58.67H.333z" />
      </clipPath>
      <clipPath id="c">
        <path fill="currentColor" d="M.333.166h106.67v58.669H.333z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgReviewProxyway
